import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../context/user/UserContext';
import StateContext from '../context/state/StateContext';
import styles from '../styles/agencies.module.css'
import { toast } from 'react-toastify';

const Agencies = () => {
  const { user, getEmployees } = useContext(UserContext);

  const { setModal, token, agencies, setAgencies, setConfirm } = useContext(StateContext);
  const url = process.env.REACT_APP_API_URL + "api/agency/";

  async function getAgencies() {
    const response = await fetch(`${url}get`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': `${token}`
      }
    });
    const result = await response.json();
    if (result.success) {
      setAgencies(result.agencies);
    }
  }

  useEffect(() => {
    getEmployees(); // Fetch employees via context function
    getAgencies();
  }, []);

  return (
    <>
      <div className="container-fluid px-0 overflow-hidden">
        <div className="heading">
          <h3>Agencies</h3>
          {user.role == "admin" ?
            <div className='btn-div' onClick={() => setModal({ open: true, component: "Agency" })}>
              <button className='learn-more' id='add'>
                <span className='circle' aria-hidden="true">
                  <span className='icon arrow'></span>
                </span>
                <span className='button-text'>Add Agency</span>
              </button>
            </div>
            : null}
        </div>

        <div className={styles.groupsContainer}>
          {agencies && agencies.length > 0 ? agencies.map((agency) => (
            <div key={agency.id} className={styles.groupCard}>
              <div className={styles.groupHeader}>
                <h2 className={styles.groupName}>{agency.name}</h2>
                {user.role === "admin" ? 
                  <button
                    className={styles.deleteButton}
                    onClick={() => {
                      setModal({ open: true, component: "Confirm" });
                      setConfirm({
                        component: "Agency",
                        ticketId: agency.id, // Corrected from ticketId to groupId since it's a group
                        text: "Are you sure you want to delete this Agency?"
                      });
                    }}
                  >
                    Delete
                  </button>
                  : null} 
              </div>
              <div className='row ps-4 pe-4 d-flex flex-column'>
                <div className='col-md-12'>
                <h3>Type: {agency.type}</h3>  
                <h3>Decs: {agency.description}</h3>
                </div>
              </div>
              <ul className={styles.userList}>
                {agency.users && agency.users.length > 0 ? (
                  agency.users.map((user, index) => (
                    <li key={index} className={styles.userItem}>
                      {user.name}
                    </li>
                  ))
                ) : (
                  <li className={styles.noUsers}>No users in this agency</li>
                )}
              </ul>
            </div>
          )) : <p>No Agency available.</p>}
        </div>
      </div>
    </>
  );
};

export default Agencies;
